module.exports = __webpack_public_path__ + "img/products.ebc9cd2d.svg";